import { Directive } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from "@angular/forms";
import { isDate } from "moment";

@Directive({
    selector: '[thresholdRange]',
    providers: [{ provide: NG_VALIDATORS, useExisting: ThresholdRangeValidator, multi: true}]
})

export class ThresholdRangeValidator implements Validator {
    validate(control: AbstractControl): ValidationErrors | null {
        const isTime = (control.value.topValue + '').includes(':') || (control.value.middleLeftValue + '').includes(':')
            || (control.value.middleRightValue + '').includes(':') || (control.value.bottomValue + '').includes(':');

        let top = control.value.topValue ?? 0;
        let middleLeft = control.value.middleLeftValue ?? 0;
        let middleRight = control.value.middleRightValue ?? 0;
        let bottom = control.value.bottomValue ?? 0;


        if (isTime) { // need to convert times
            top = this.getSeconds(top + '');
            middleLeft = this.getSeconds(middleLeft + '');
            middleRight = this.getSeconds(middleRight + '');
            bottom = this.getSeconds(bottom + '');
        }
        else {
        	top = parseFloat(top);
        	middleLeft = parseFloat(middleLeft);
        	middleRight = parseFloat(middleRight);
        	bottom = parseFloat(bottom);
        }

        let topValid = true;
        let middleLeftValid = true;
        let middleRightValid = true;
        let bottomValid = true;

        if (control.value.topEnabled) {
            if (control.value.middleEnabled) {
                topValid = top > middleLeft && top > middleRight; 
                middleLeftValid = top > middleLeft;
                middleRightValid = top > middleRight;
            }
            if (control.value.bottomEnabled) {
                topValid = topValid && top > bottom;
                bottomValid = bottomValid && top > bottom;
            }
        }

        if (control.value.middleEnabled) {
            middleLeftValid = middleLeftValid && middleRight > middleLeft;
            middleRightValid = middleRightValid && middleRight > middleLeft;

            if (control.value.bottomEnabled) {
                middleLeftValid = middleRightValid && middleLeft > bottom;
                bottomValid = bottomValid && middleLeft > bottom;
            }
        }

        if (!topValid || !middleLeftValid || !middleRightValid || !bottomValid) {
            return {
                'top': !topValid,
                'middleLeft': !middleLeftValid,
                'middleRight': !middleRightValid,
                'bottom': !bottomValid,
                'range': true
            }
        } else return null;
    }

    /** converts a time string to seconds */
    getSeconds(value: string) {
        let seconds = 0;
        const segments = value.split(':');
        for(let i = 0; i <= segments.length; i++) {
            let parsed = parseInt(segments[i], 10)
            if (Number.isNaN(parsed))
                seconds += 0;
            else
                seconds += parsed * Math.pow(60, segments.length - (i + 1));
        }
        return seconds;
    }
}